import MediaIcon from './component.jsx'
export default MediaIcon
